import { fetcher } from "../switchless-redux-actions";

/**
 * Initialize a fetcher with instance options.
 * @param {Object} options - Initialization options
 * @param {string} options.url - Base url for HTTP requests
 * @param {string} options.store - Store instance
 * @param {string} options.connect - Connect instance
 * @param {Object} store - Redux store dispatching actions
 * @param {Object} connect - Connect instance
 * @return {fetchingCallback} Fetching function dispatching the action. It returns a Promise so
 * that a custom `.catch` can be added.
 *
 * @name fetcher
 * @example
 *
 * import { fetcher } from "@weezevent/sauron";
 * let fetcherFn = () => {};
 *
 * export initialize({ url, store, connect }) {
 *     fetcherFn = fetcher({ url, store, connect });
 * }
 *
 * export default (action) => fetcherFn(action);
 */
export default ({ url, store, connect }) => {
	const requestApi = fetcher({
		url,
		store
	});

	return (action, headers = action.headers()) => {
		const { token } = connect.getToken();
		headers.Authorization = `Bearer ${token}`;
		return requestApi(action, headers);
	};
};

/**
 * @typedef {function} fetchingCallback
 * @param {Object} action - Action to request on the server-side
 * @param {Object} [headers=action.headers()] - Action headers for the HTTP request
 * @return {Promise}
 */

/**
 *
 * Toast home made fetcher
 *
 */

let _connect = false;

export function initialize(connect) {
	_connect = connect;
}

const request = async (endPoint, method, params, body, signal) => {
	const { token } = await _connect.getToken();
	let config = {
		method: method,
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json"
		},
		signal
	};

	let url;
	if (endPoint.indexOf("http") === 0) {
		url = endPoint;
	} else {
		url = window.weezConfig.api.apiUrl + endPoint;
	}

	if (params) {
		config.params = params; // note: this doesn't make any sense there's not "params" param in fetch
	}

	if (body) {
		config.body = body; // note: we say content-type: application/json so why don't we JSON.stringify this ?
	}

	if (token) {
		config.headers = {
			...config.headers,
			Authorization: `Bearer ${token}`
		};
	}

	return fetch(url, config)
		.then(handleErrors)
		.then(response => {
			let dataPromise;
			let contentType = response.headers.get("content-type");
			if (contentType && contentType.indexOf("application/json") !== -1) {
				dataPromise = response.json();
			} else {
				dataPromise = response.text();
			}
			return dataPromise.then(data => ({
				data,
				headers: response.headers
			}));
		});
};

// Handle HTTP errors
function handleErrors(response) {
	if (!response.ok) {
		return response.text().then(text => {
			let error = new Error(
				`${response.url}, status: ${response.status}, msg: ${text}`
			);
			error.status = response.status;
			error.url = response.url;
			error.headers = response.headers;
			error.text = text;
			throw error;
		});
	}
	return response;
}

export function GET(endPoint, params = false, signal) {
	return request(endPoint, "GET", params, null, signal);
}

export function POST(endPoint, body = false, signal, queryParams = null) {
	return request(endPoint, "POST", queryParams, body, signal);
}

export function PUT(endPoint, body = false, signal, queryParams = null) {
	return request(endPoint, "PUT", queryParams, body, signal);
}

export function PATCH(endPoint, body = false, signal, queryParams = null) {
	return request(endPoint, "PATCH", queryParams, body, signal);
}

export function DELETE(endPoint, params = false, signal) {
	return request(endPoint, "DELETE", params, signal);
}
